module.exports = __webpack_public_path__ + "static/media/Artboard10.c001bade.png";